import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import logoIcon from '../../../assets/images/logo-short-Q.png';
import './style.scss';
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {RouterState} from "connected-react-router";
import {LayoutState} from "../../../store/layouts/types";
import ClockComponent from "../../reusable/ClockComponent";
import DateComponent from "../../reusable/DateComponent";
import { Routes } from '../../../types';

const LogoDateComponent = () => {
    const ref = useRef<HTMLDivElement>(null);
    const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
    const {currentLayout} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const [title, setTitle] = useState('');
    const isBrowse = location.pathname === Routes.browse;

    useEffect(() => {
        if (location.pathname === Routes.alerts || location.pathname === Routes.bookmarks || !currentLayout.name) {
            setTitle(location.pathname.slice(1).toUpperCase())
        } else {
            setTitle(currentLayout.name)
        }
    }, [currentLayout, location.pathname]);

    return (
        <div className='logo-date-wrapper'
             ref={ref}
        >
            <div>
                <img src={logoIcon} alt="logo" width={'90%'}/>
            </div>
            <div className='logo-bord'>
                <DateComponent className="date" />
                {/* { !isBrowse && <DateComponent className="date" /> } */}
                { title && title }
                <ClockComponent className="clock" />
                {/* { isBrowse && <ClockComponent className="clock" /> } */}
            </div>

        </div>
    )
};

export default LogoDateComponent